module.exports = __webpack_public_path__ + "static/img/guidedetail-bg.4195822.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guidedetail-bg.jpg
// module id = 2YPY
// module chunks = 1